export const FIRST_NAME_LABEL = 'First Name';
export const LAST_NAME_LABEL = 'Last Name';
export const EMAIL_LABEL = 'Email';

export const FIRST_NAME_PLACE_HOLDER = 'First Name';
export const LAST_NAME_PLACE_HOLDER = 'Last Name';
export const EMAIL_PLACE_HOLDER = 'Email';
